export enum ViewModalAction {
  Run = 'run',
  SaveAndRun = 'saveAndRun',
  Reset = 'reset',
}
